import React, { useRef, useState, useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";

export const digitosFirma = 6;

export function Otp(props) {
  const { updateToken } = useContext(AuthContext);

  const [otp, setOtp] = useState(Array(digitosFirma).fill(""));
  const inputsRef = useRef([]);

  const focusInput = (index) => {
    inputsRef.current[index]?.focus();
  };

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");

    // 🔥 OTP COMPLETO (mobile autofill / paste)
    if (value.length >= digitosFirma) {
      const values = value.slice(0, digitosFirma).split("");
      setOtp(values);
      updateToken(values.join(""));
      focusInput(digitosFirma - 1);
      return;
    }

    // 🔹 PEGADO PARCIAL
    if (value.length > 1) {
      const newOtp = [...otp];
      value.split("").forEach((v, i) => {
        if (index + i < digitosFirma) {
          newOtp[index + i] = v;
        }
      });
      setOtp(newOtp);
      updateToken(newOtp.join(""));
      focusInput(Math.min(index + value.length, digitosFirma - 1));
      return;
    }

    // 🔹 ESCRITURA NORMAL
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    updateToken(newOtp.join(""));

    if (value && index < digitosFirma - 1) {
      focusInput(index + 1);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      focusInput(index - 1);
    }
  };

  return (
    <div className="flex justify-center">
      {otp.map((value, index) => {
        return (
          <React.Fragment key={index}>
            <input
              ref={(el) => (inputsRef.current[index] = el)}
              value={value}
              type="text"
              inputMode="numeric"
              autoComplete={index === 0 ? "one-time-code" : "off"}
              enterKeyHint="done"
              className="text-purple mx-1 text-lg py-1 w-10 text-center border-2 rounded-md"
              maxLength={index === 0 ? digitosFirma : 1} // 🔥 CLAVE
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
            />
            {index === otp.length - 1 ? null : (
              <span className="w-2 py-0.5 text-purple/40">-</span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
